import { Component, OnInit } from '@angular/core';

import { AmplitudeService } from '../services/amplitude.service';
@Component({
  selector: 'cc-mobile-store-buttons',
  templateUrl: './mobile-store-buttons.component.html',
  styleUrls: ['./mobile-store-buttons.component.scss']
})
export class MobileStoreButtonsComponent implements OnInit {
  constructor(private amplitudeService: AmplitudeService) {}

  ngOnInit() {}

  openLinkApp(app: string) {
    this.amplitudeService.logEvent('Panel:Mobile:Download', {
      os: app
    });
  }
}
